import { graphql, Link } from "gatsby"
import React from "react"
import { useLayout } from "contexts/components/LayoutContext"
import { getRelativePathFromCodex } from "components/button/utils/getRelativePathFromCodex"

type ServiceArea = {
  id: string
  title: string | null
  slug: string | null
}

interface ServiceAreaGroupProps {
  heading: string | null
  sub_heading: string | null
  eyebrow_text: string | null
  alternate_background_color: boolean
  service_areas: ServiceArea[]
}

export const ServiceAreaGroup = ({
  heading,
  sub_heading,
  eyebrow_text,
  service_areas,
  alternate_background_color,
}: ServiceAreaGroupProps) => {
  const { linkedPagesUrlPathCodex } = useLayout()

  return (
    <section
      className={
        alternate_background_color
          ? `u-content-block-padding alternate-background-color`
          : `u-content-block-padding`
      }
    >
      <div className="fr-container text-content-block">
        {heading && <h2>{heading}</h2>}
        <div className="fr-content-container fr-content-list">
          <ul>
            {service_areas &&
              service_areas.map(({ id, title, slug }) => {
                const hasSlug = !!slug

                const relativePath = getRelativePathFromCodex({
                  codex: linkedPagesUrlPathCodex,
                  path: slug,
                  codexKeyStartsWithForwardSlash: false,
                })

                return (
                  <li>
                    {hasSlug ? (
                      <Link key={id} to={relativePath}>
                        {title}
                      </Link>
                    ) : (
                      <p key={id}>{title}</p>
                    )}
                  </li>
                )
              })}
          </ul>
        </div>
      </div>
    </section>
  )
}

export const query = graphql`
  fragment StrapiServiceAreaGroupFragment on STRAPI__COMPONENT_CONTENT_BLOCK_LOCATION_GROUP {
    id
    strapi_component
    eyebrow_text
    heading
    sub_heading
    alternate_background_color
    service_areas {
      slug
      service_area_name
    }
  }
`
